import React from 'react';
import { IconButton } from '../../../../../../common/controls/Controls.jsx';
import {
  RedoOutlined,
  FileSearchOutlined,
  TeamOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { routes } from '../../../../../../../utils/helpers/ApiClient.jsx';
import {
  dataGridDateSorter,
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { Tag } from 'antd';
import {
  statusColorJob,
} from '../../../../../../../utils/constants/enums.js';

export const ArchivedJobsConfig = ({
  t,
  navigate,
  permissions,
  filterHooks,
}) => {
  return {
    columns: [
      {
        title: t('Názov'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...filterHooks.nameTextFilterProps,
      },
      {
        title: t('Lektor'),
        dataIndex: 'supervisor_full_name',
        sorter: dataGridTextSorter('supervisor_full_name'),
        ...filterHooks.supervisorTextFilterProps,
      },
      {
        title: t('Začiatok'),
        dataIndex: 'date_from',
        sorter: dataGridDateSorter('date_from'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...filterHooks.fromDateRangeFilterProps,
      },
      {
        title: t('Koniec'),
        dataIndex: 'date_to',
        sorter: dataGridDateSorter('date_to'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...filterHooks.toDateRangeFilterProps,
      },
      {
        title: t('Praktikanti'),
        dataIndex: 'accepted',
        sorter: dataGridNumberSorter('accepted'),
      },
      {
        title: t('Stav'),
        dataIndex: 'status',
        sorter: dataGridTextSorter('status'),
        ...filterHooks.statusTextFilterProps,
        render: (status) => (
          <Tag color={statusColorJob(status)}>{t(status)}</Tag>
        ),
      },
    ],

    customActions: (record) => (
      <div style={{ display: 'flex' }}>
        {permissions.isFijAdmin && (
          <IconButton
            icon={<EditOutlined />}
            tooltip={t('Upraviť')}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`${routes.cmsFijJobEdit}/${record.id}`);
            }}
          />
        )}

        {(permissions.isFijAdmin ||
          (permissions.isFijLecturer &&
            record.supervisor_id === permissions.userId)) && (
          <>
            <IconButton
              icon={<RedoOutlined />}
              tooltip={t('Obnoviť FRI prax z archívu')}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${routes.cmsFijJobCreate}?restore_from=${record.id}`);
              }}
            />
            <IconButton
              icon={<TeamOutlined />}
              tooltip={t('Zobraziť záujemcov / praktikantov')}
              disabled={
                (record.interested === 0 || record.interested === '0') &&
                (record.accepted === 0 || record.accepted === '0')
              }
              disabledTooltip={t('Nie sú záujemcovia / praktikanti')}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${routes.cmsFijInterestedStudents}/${record.id}`);
              }}
            />
          </>
        )}

        <IconButton
          icon={<FileSearchOutlined />}
          tooltip={t('Zobraziť detail')}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${routes.cmsFijJobDetail}/${record.id}`);
          }}
        />
      </div>
    ),

    modals: () => null,
  };
};
